import { type Theme } from '@mui/material/styles'

import { createTheme } from '@Material/material'

export const darkTheme: Theme = createTheme(true)

export const lightTheme: Theme = createTheme(false)
